import axios from 'axios'
import authHeader from './auth-header'
import Config from '../../config'
import Vue from 'vue'

if (!Vue.prototype.$apiServers) {
  Vue.prototype.$apiServers = Config.apiServers
}

class AddressLogService {
  getSummary() {
    return axios.get(`${Vue.prototype.$apiServers.url}/admin/address-logs/summary`, {
      headers: authHeader(),
    }).then(response => response.data)
  }

  getUserDetail(userId, page = 1, limit = 50) {
    return axios.get(`${Vue.prototype.$apiServers.url}/admin/address-logs/user/${userId}`, {
      params: { page, limit },
      headers: authHeader(),
    }).then(response => response.data)
  }
}

export default new AddressLogService()
